import { stylesheet, types } from 'typestyle';

const defaultButtonZoneTextStyle: types.NestedCSSProperties = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  width: '100%',
};

export const ButtonZoneTextStyle = stylesheet({
  tabButtonZoneText: { ...defaultButtonZoneTextStyle },

  tabButtonZoneTextDisabled: {
    color: '#808080',
    ...defaultButtonZoneTextStyle,
  },
});
